export default function Wave(props: { fill: string }) {
  return (
    <svg
      width="800"
      height="66"
      viewBox="0 0 800 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0)">
        <path
          d="M81.7966 13.0182C221.592 13.0182 252.019 54.04 359.413 60C440.5 64.5 508.708 23.5455 588 33.5C703.5 48 794.305 10.266 794.5 -8H-33V38.5697C-23.3514 38.5697 1.27454 13.0182 81.7966 13.0182Z"
          fill={props.fill}
        />
      </g>
    </svg>
  )
}
